
<ng-template #loading>
    <app-mat-spinner-overlay text="Vent litt..."></app-mat-spinner-overlay>
</ng-template>

<div *ngIf="data; else loading" class="flex-column flex-gap-20">
    <div class="alert-warning" role="alert" [innerHtml]="getLabelValue('ConsentText') | safe: 'html'"></div>

    <div class="flex-row flex-gap-20">
        <button mat-raised-button color="primary" class="flex-half finkn-btn big-btn" (click)="setConsent(true)" type="button" [innerHtml]="getLabelValue('ConsentTextYes') | safe: 'html'"></button>
        <button mat-raised-button color="primary" class="flex-half finkn-btn big-btn" (click)="setConsent(false)" type="button" [innerHtml]="getLabelValue('ConsentTextNo') | safe: 'html'"></button>
    </div>
</div>
